(function () {
  var HIDDEN_CLASS = 'u-hidden';
  var menuEl = document.querySelector('[data-component="menu"]');
  if (!menuEl) {
    return;
  }
  var moreEl = menuEl.querySelector('[data-element="menu-more"]');
  var restItemsEl = menuEl.querySelector('[data-element="menu-rest-items"]');
  var itemsEl = menuEl.querySelectorAll('[data-element="menu-item"]');
  var removeChildren = function removeChildren(el) {
    while (el.firstChild) {
      el.removeChild(el.firstChild);
    }
  };
  var getFirstItemInLineIndex = function getFirstItemInLineIndex(items) {
    var offset = null;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (i === 0) {
        offset = item.offsetTop;
      }
      if (item.offsetTop > offset) {
        return i;
      }
    }
    return null;
  };
  var hideExtraItems = function hideExtraItems() {
    menuEl.prepend(moreEl);
    removeChildren(restItemsEl);
    var items = Array.from(itemsEl);
    items.forEach(function (item) {
      return item.classList.remove(HIDDEN_CLASS);
    });
    var firstItemInLineIndex = getFirstItemInLineIndex(itemsEl);
    if (typeof firstItemInLineIndex === 'number') {
      var restItems = items.splice(firstItemInLineIndex, itemsEl.length - 1);
      restItems.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.className = '.p-menu__dropdown-item';
        clone.getElementsByTagName('a')[0].className = 'p-menu__dropdown-link';
        restItemsEl.appendChild(clone);
        item.classList.add(HIDDEN_CLASS);
      });
      moreEl.classList.remove(HIDDEN_CLASS);
    }
    if (firstItemInLineIndex === null) {
      moreEl.classList.add(HIDDEN_CLASS);
    }
    menuEl.append(moreEl);
  };
  hideExtraItems();
  window.addEventListener('resize', function () {
    return setTimeout(hideExtraItems, 10);
  });
  window.addEventListener('load', hideExtraItems);
})();